import { observer } from 'mobx-react-lite'
import { IgnoreMergeRequestDialog } from '@/features/admin/account-linking/IgnoreMergeRequestDialog'
import { type IgnoreMergeRequestDialogViewModel } from './IgnoreMergeRequestDialogViewModel'

export interface IgnoreMergeRequestDialogContainerProps {
  vm: IgnoreMergeRequestDialogViewModel
}

export const IgnoreMergeRequestDialogContainer = observer(
  function IgnoreMergeRequestDialogContainer({
    vm,
  }: IgnoreMergeRequestDialogContainerProps) {
    return (
      <IgnoreMergeRequestDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onIgnore={vm.ignore}
        isIgnorePending={vm.ignore.pending}
        customerDisplayName={vm.customerDisplayName}
      />
    )
  },
)
